

export default {
  name: 'MotorhomeListingDataChips',
  props: {
    product: {
      type: Object,
      default: () => Object()
    },
    expanded: {
      type: Boolean,
      default: true
    },
    useAttributes: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    values () {
      if (this.useAttributes) {
        return this.chipsFromAttributes
      } else {
        return this.chips
      }
    },

    chipsFromAttributes () {
      const chips = []
      Object.values(this.product.attributes).forEach((attr) => {
        switch (attr.attributeCode) {
          case 'category':
          case 'chassis_select':
            chips.push({
              text: attr.optionLabel
            })
            break
          case 'transmission':
            if (!this.expanded) {
              chips.push({
                text: attr.optionLabel,
                attributeCode: attr.attributeCode
              })
            }
            break

          case 'power':
          case 'first_registration':
          case 'mileage':

            chips.push({
              attributeCode: attr.attributeCode,
              text: this.formatValue(attr.attributeCode,
                attr.backendType,
                attr.value)
            })
            break
          default:
        }
      })
      return chips
    },

    chips () {
      const {
        category,
        firstRegistration,
        mileage,
        power,
        chassisSelect,
        transmission
      } = this.product

      const chips = [
        { text: category },
        { text: this.format('first_registration', 'datetime', firstRegistration) },
        { text: this.format('mileage', 'int', mileage) },
        { text: this.format('power', 'int', power) },
        { text: chassisSelect }
      ]

      if (this.expanded) {
        chips.push({ text: transmission })
      }

      return chips
    }
  },
  methods: {
    formatValue (attributeCode, backendType, value) {
      return this.$eavFormatter.formatValue(attributeCode, backendType, value)
    },
    format (attributeCode, backendType, value) {
      if (attributeCode === 'hu_valid_through' && (!value)) {
        attributeCode = 'hu_expired'
        value = true
      }

      return this.$eavFormatter.format(attributeCode, backendType, value)
    }
  }
}
